import axios from 'axios'
import store from './store/index.js'

//redEnvelopActivityId  redEnvelopTemplate
let gob = {
  api: {
    test:{
      mainApi: 'http://192.168.9.69:8001/offerMolecule'
      // mainApi: 'http://192.168.10.50:8001/offerMolecule'//周青
    },
    uat:{
      mainApi: 'http://61.144.45.10:10001/gmms/gmmsEnvelopeApi/bbguat/offerMolecule',
    },
    bbguat:{
      mainApi: 'https://www.26dudt.com/gmms/squareNineApi/bbguat/offerMolecule',
    },
    pro:{
      mainApi: 'https://mbank.bankofbbg.com/cismp/gmms/api/molecule/offerMolecule'
    }
  },
  getApi: function () {
    const apiData = this.api;
    const hostname = window.location.hostname;
    if (hostname === "mbank.bankofbbg.com") {
      return apiData.pro;
    } else if (hostname === '192.168.9.49' || hostname === 'localhost') {
      return apiData.test;
    } else if (hostname === 'www.26dudt.com') {
      return apiData.bbguat;
    } else {
      return apiData.uat;
    }
  },
  isJSON(str) {
    if (typeof str == 'string') {
      try {
        JSON.parse(str);
        return true;
      } catch(e) {
        return false;
      }
    }
  },
  //域名配置
  post: function (vueObj,options, newUrl) {
    store.dispatch('setState', { name: 'LoadingOnOff', value: true })
    var headers={
      'Content-Type':'application/json;charset=utf-8',
      'token':gob.getCookie('squareNineToken')
    }
    if(!options.arg) options.arg={};
    const token=gob.getCookie('squareNineToken');
    if(vueObj.$route.meta.needLogin&&!token){
      gob.loginout(vueObj);
    }
    options.arg.token=token
    const ipName =newUrl?newUrl:gob.getApi().mainApi;
    const url=options.url?ipName + options.url:ipName;
    return new Promise(function (resolve, reject) {
      axios.post(
        url,
        options.arg,
        {headers:headers}
      ).then(function (response) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
            gob.handleResStatus(vueObj,response.data,()=>{
              resolve(response.data);
            },()=>{
              reject(response.data);
            })
        })
        .catch(function (error) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
          if(!options.noFailTip) gob.changeStore('AppTopTip', {onOff: true, text:'请求失败'})
          reject(error);
        });
    })
  },
  get: function (vueObj,options, newUrl) {
    store.dispatch('setState', { name: 'LoadingOnOff', value: true })
    var headers={
      'token':gob.getCookie('squareNineToken')
    }
    if(!options.arg) options.arg={};
    const token=gob.getCookie('squareNineToken');
    if(vueObj.$route.meta.needLogin&&!token){
      gob.loginout(vueObj);
    }
    options.arg.token=token
    const ipName =newUrl?newUrl:gob.getApi().mainApi;
    const url=options.url?ipName + options.url:ipName;
    return new Promise(function (resolve, reject) {
      axios.get(
        url,
        {
          params: options.arg,
          headers: headers,
        }
      ).then(function (response) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
          gob.handleResStatus(vueObj,response.data,()=>{
            resolve(response.data);
        },()=>{
            reject(response.data);
          })
        })
        .catch(function (error) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
          if(!options.noFailTip) gob.changeStore('AppTopTip', {onOff: true, text:'请求失败'})
          reject(error);
        });
    })
  },
  //域名配置
  handleResStatus:function(vueObj,resJson,callback,reject) {
    // 处理正常返回的状态
    var resultCode = resJson.code;
    var resultInfo = resJson.msg||resJson.desc;
    const successCode=['200','101','0','102','8008'];
     if (successCode.includes(resultCode)) {
      callback && callback()
    }else if (resultCode == 8006) {
      gob.changeStore('AppTopTip', {onOff: true, text: resultInfo})
      gob.loginout(vueObj)
    }else if (resultCode == '56465' || resultCode == '56464') {
      vueObj.$router.push({
        path: '/overDue', query: {code: resultCode}
      })
    }else{
      gob.changeStore('AppTopTip', {onOff: true, text: resultInfo})
      if (reject) reject();
    }

  },

  loginout(vueObj){
    gob.clearCookie('squareNineToken');
    // vueObj.$router.push("/login/"+localStorage.redEnvelopActivityId);
  },
  //改变store
  changeStore: function (name,param) {
    if(name==='AppTopTip'&&store.state.AppTopTip.onOff) return;
    store.dispatch('setState', { name:name, value: param})
  },
  postSM4(vueObj,options, newUrl){
    store.dispatch('setState', { name: 'LoadingOnOff', value: true })
    var reqData={data:options.arg,sign: 1};
    var headers={
      'Content-Type':'application/json;charset=utf-8',
    }
    const ipName =newUrl?newUrl:gob.getApi().mainApi;
    const url=options.url?ipName + options.url:ipName;
    return new Promise(function (resolve, reject) {
      axios.post(
        url,
        reqData,
        {headers:headers}
      ).then(function (response) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
          gob.handleResStatus(vueObj,response.data,()=>{
            resolve(response.data);
        },()=>{
            reject(response.data);
          })
        })
        .catch(function (error) {
          store.dispatch('setState', { name: 'LoadingOnOff', value: false });
          if(!options.noFailTip) gob.changeStore('AppTopTip', {onOff: true, text:'请求失败'})
          reject(error);
        });
    })
  },
  encryptSM4(word){
    const JSSM4=require("jssm4");
    var sKey = "JeF8U9wHFOMfs2Y8";
    var sm4 = new JSSM4(sKey);
    var endata = sm4.encryptData_ECB(JSON.stringify(word));
    return endata
  },
  decryptSM4(word){
    const JSSM4=require("jssm4");
    var sKey = "JeF8U9wHFOMfs2Y8";
    var sm4 = new JSSM4(sKey);
    var dedata = sm4.decryptData_ECB(word);
    if(gob.isJSON(dedata)){
      return JSON.parse(dedata);
    }else{
      return {resultCode:"500",error_msg:dedata,resultInfo:dedata};
    }

  },
  setCookie(cname,cvalue,exdays){
    // squareNineToken
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },
  getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++)
    {
      var c = ca[i].trim();
      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
  },
  clearCookie(cname){
    gob.setCookie(cname, "", -1);
  },
  //获取时间差
  getDiff: function (time) {
    var diff = '';
    var time_diff = null;
    if (time > new Date().getTime()) {
      time_diff = time - new Date().getTime();
    } else {
      time_diff = new Date().getTime() - time;
    }
    // 计算相差天数
    var days = Math.floor(time_diff / (24 * 3600 * 1000));
    if (days > 0) {
      diff += days + '天';
    }
    // 计算相差小时数
    var leave1 = time_diff % (24 * 3600 * 1000);
    var hours = Math.floor(leave1 / (3600 * 1000));
    if (hours > 0) {
      diff += hours + '小时';
    } else {
      if (diff !== '') {
        diff += hours + '小时';
      }
    }
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000);
    var minutes = Math.floor(leave2 / (60 * 1000));
    if (minutes > 0) {
      diff += minutes + '分';
    } else {
      if (diff !== '') {
        diff += minutes + '分';
      }
    }
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000);
    var seconds = Math.round(leave3 / 1000);
    if (seconds > 0) {
      diff += seconds + '秒';
    } else {
      if (diff !== '') {
        diff += seconds + '秒';
      }
    }
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  },

  //事件委托
  getTargetObj: function (classStr, callback) {
    $(document).off('click').on('click', function (ev) {
      var oEvent = ev || event;
      oEvent.cancelBubble = true;
      var targetObj = $(ev.target);
      if (targetObj.attr('class') && targetObj.attr('class').indexOf(classStr) != -1) {
        callback(targetObj);
      }
    });
  },
  isIOS: function () {
    if (/android/i.test(navigator.userAgent)) {
      return 0
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      return 1
    }
  },

  //是否为浮点
  isFloat: function (num) {
    return !(/(^[0-9]*[1-9][0-9]*$)/.test(num));
  },
  getToday:function(){
    return new Date().toLocaleDateString().split("/").join('-');
  },
  getTodayFull:function(time){
    var dataObj=time?new Date(time):new Date();
    return dataObj.toLocaleDateString()+' '+dataObj.getHours()+':'+dataObj.getMinutes()+':'+dataObj.getSeconds()
  },
  parseTime:function(time, cFormat) {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string')) {
        if ((/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else {
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }

      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
      return value.toString().padStart(2, '0')
    })
    return time_str
  },
  escape:function(str) {
    str = str.replace(/&/g, '&amp;')
    str = str.replace(/</g, '&lt;')
    str = str.replace(/>/g, '&gt;')
    str = str.replace(/"/g, '&quto;')
    str = str.replace(/'/g, '&#39;')
    str = str.replace(/`/g, '&#96;')
    str = str.replace(/\//g, '&#x2F;')
    return str
  },
  getQuery(json){
    var b="";
    for(var key in json){
      b+=`&${key}=${json[key]}`
    }
    return b.substring(1);
  },
  //判断小程序环境
  isMiniProgram: function (callback) {
    if (!!navigator.userAgent.toLowerCase().match(/microMessenger/i)) { //微信环境
      wx.miniProgram.getEnv(function (res) {
        callback(res.miniprogram)
      })
    } else { //非微信环境逻辑
      console.log('非微信');
      callback(false)
    }
  },
}

export default gob



// WEBPACK FOOTER //
// ./src/gob.js